const RETRIED_KEY = 'platform.callback.retried';

const sessionStore = (): Storage | null => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const hasRetriedSignIn = (): boolean => sessionStore()?.getItem(RETRIED_KEY) === 'true';

export const markSignInRetried = (): void => {
  sessionStore()?.setItem(RETRIED_KEY, 'true');
};

export const forgetSignInRetry = (): void => {
  sessionStore()?.removeItem(RETRIED_KEY);
};
